import { render, staticRenderFns } from "./Encerrar.vue?vue&type=template&id=58fb441e&lang=pug&"
import script from "./Encerrar.vue?vue&type=script&lang=js&"
export * from "./Encerrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports